orders-planner-dialog-tooltip-orders-phase(class="{show: isShow}")
  .orders-planner-dialog-tooltip-orders-phase.popper
    planner-tooltip-orders-phase(tag-scope="planner_tooltip_orders_phase")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.tooltip-orders-phase');
